export enum PaymentEnum {
  AmountToPay = 'Kwota do zapłaty: ',
  AnonymousPaymentConfirmation = 'Potwierdzamy zakup ubezpieczenia w Mubi!',
  ApplePay = 'Apple Pay',
  AuthorizationBankTransfer = 'Autoryzacji dokonasz na stronie banku.',
  BLIK = 'BLIK',
  BankAccountNumber = 'Nr konta bankowego: ',
  BlikCode = 'Kod BLIK',
  BlikCodeDescription = 'z\xa0aplikacji banku',
  BlikPaymentErrorOccured = 'Nie udało się potwierdzić płatności BLIK w\xa0aplikacji banku. Sprawdź, czy masz wystarczające środki na\xa0Twoim koncie.',
  CARD = 'Karta płatnicza',
  ChangePaymentMethod = 'Zmień metodę płatności',
  ChooseBankOrWireTransfer = 'Wybierz bank lub przelew tradycyjny',
  ChooseYourBank = 'Wybierz Twój bank',
  CloseButtonLabel = 'Zamknij',
  ConfirmBlikPayment1 = 'Potwierdź płatność PINem w\xa0aplikacji banku',
  ConfirmBlikPayment2 = 'w\xa0Twoim telefonie...',
  DocumentSendNoEmailAddress = 'Dokumenty oraz dane do płatności wysłaliśmy również na Twojego maila.',
  DocumentSent = 'Dokumenty oraz dane do płatności wysłaliśmy również na Twojego maila: ',
  DownloadApplication = 'pobierz wniosek.',
  DownloadApplicationInfo = 'Wniosek możesz pobrać także teraz: ',
  DownloadPolicy = 'pobierz polisę.',
  DownloadPolicyInfo = 'Polisę możesz pobrać także teraz: ',
  ErrorOccured1 = 'Ups! Coś\xa0poszło\xa0nie\xa0tak...',
  FastOnlineTransfer = 'Szybki przelew online',
  GPay = 'Google Pay',
  GoToPayment = 'Przejdź do płatności',
  GoToResultsButton = 'Przejdź do rankingu ofert',
  GoToResultsLabel = 'Przejdź do rankingu by wybrać inną ofertę:',
  ImojeConsent1 = 'Płacąc za pośrednictwem ING Pay oświadczasz, że zapoznałeś się i\xa0akceptujesz ',
  ImojeConsent2 = 'Regulamin ING Pay',
  ImojeConsent3 = ' oraz ',
  ImojeConsent4 = 'Informację o\xa0danych osobowych ING Pay',
  ImojeConsent5 = '.',
  ImojeRODOLink = 'https://data.imoje.pl/docs/pl/ingpay_informacja_administratora_danych_osobowych.pdf',
  ImojeRegulationsLink = 'https://data.imoje.pl/docs/pl/ingpay_regulamin_platnosci.pdf',
  Installment = 'RATA',
  InstallmentPaymentConfirmation = 'potwierdzamy płatność kolejnej raty!',
  InstallmentPaymentConfirmationLast = 'potwierdzamy płatność ostatniej raty!',
  InstallmentsThankYouForPurchasing = 'Dziękujemy i\xa0życzymy bezszkodowej jazdy.',
  InvalidBlikCode = 'Niepoprawny kod BLIK',
  NextInstallmentPaymentDeadline = 'Termin płatności następnej raty to: ',
  Of = 'Z',
  Online = ' online',
  OnlineOrTraditionalTransfer = 'Przelew online lub tradycyjny',
  OnlineTransfer = 'Przelew online',
  Paid = 'OPŁACONA',
  PayByBlik = 'Zapłać BLIKIEM',
  PayByTransfer = 'Zapłać przelewem',
  PayInstallment = 'Opłać ratę',
  PayInstallment1 = 'opłać',
  PayInstallment2 = 'ratę za polisę',
  PayInstallment3 = 'dla',
  PayInstallment4 = 'z',
  PayNowForPolicy = 'Dokonaj płatności już teraz.',
  PayPo = 'PayPo',
  PayPoLong = 'PayPo - Kup teraz zapłać za 30 dni',
  PayPolicy = 'Opłać polisę',
  PayeeDetails = 'Dane odbiorcy: ',
  PaymentConfirmation = 'potwierdzamy płatność za polisę!',
  PaymentDeadline = 'Termin płatności mija',
  PaymentDetails = 'Dane do płatności',
  PaymentDetailsWarning1 = 'Uwaga - nie zmieniaj tytułu ani kwoty przelewu!',
  PaymentDetailsWarning2 = 'Pamiętaj o dokonaniu płatności do ',
  PaymentDetailsWarning3 = ', aby ubezpieczenie było ważne.',
  PaymentInVerificationHeading = 'Twoja płatność jest\nw\xa0trakcie weryfikacji.',
  PaymentInVerificationText1 = 'Jeśli płatność przebiegła pomyślnie, nie musisz nic robić – polisę prześlemy na Twój adres email.',
  PaymentInVerificationText1Installments = 'Jeśli płatność przebiegła pomyślnie, nie musisz nic robić, potwierdzenie prześlemy na Twój adres email.',
  PaymentInVerificationText2 = 'Masz pewność, że płatność się nie powiodła?',
  PaymentInVerificationText3 = 'Opłać\xa0ponownie',
  PaymentMethods = 'Metody płatności',
  PaymentTimedOut = 'Niestety czas na opłacenie tego ubezpieczenia już minął...',
  PaymentTitle = 'Tytuł płatności: ',
  PaymentWaitingHeading = 'Transakcja oczekuje\nna potwierdzenie...',
  PaymentWaitingText1 = 'Oczekiwanie na potwierdzenie z banku.',
  PaymentWaitingText2 = 'Chcesz spróbować opłacić ponownie?',
  PaymentWaitingText3 = 'Kliknij\ntutaj',
  PolicyAlreadyPaidErrorOccured = 'Wygląda na to, że polisa została już opłacona.',
  PolicyPaidAndValid = 'Twoja polisa jest opłacona i\xa0ważna do: ',
  PolicyValidDate = 'Ochrona rozpoczyna się',
  PolicyValidDate2 = 'Twoja polisa będzie ważna od:',
  PolicyWithDocsSendToEMail = 'Polisę wraz z wymaganymi dokumentami wysłaliśmy na Twojego maila',
  PurchasingConfirm = 'potwierdzamy zakup ubezpieczenia w\xa0Mubi!',
  PurchasingFailed = 'Twoja płatność nie powiodła się.',
  RegisterTransactionErrorOccured = 'Nie udało się zainicjować transakcji. Spróbuj ponownie lub wybierz inną metodę płatności.',
  RemindAboutPayment = 'Dokonaj płatności by otrzymać polisę.',
  RemindAboutPayment2 = 'Opłać teraz aby zachować ciągłość ochrony.',
  RemindAboutPaymentWithHour = 'Aby otrzymać polisę, dokonaj płatności do godz. ',
  RenewalPolice = 'odnów swoją polisę',
  SendTransferBy = 'Zrealizuj do: ',
  ShowLess = 'Pokaż mniej',
  ShowMore = 'Pokaż więcej',
  SubTitleBlik = 'Wpisz 6-cyfrowy kod BLIK',
  SubTitleCard = 'Wprowadź dane karty',
  SubTitleOnlineTransfer = 'Wybierz swój bank',
  SubTitlePayPo = 'Zapłać do 30 dni',
  SubTitleTransfer = 'Online lub tradycyjny',
  ThankYouForPurchasing = 'Dziękujemy za zakup ubezpieczenia w\xa0Mubi i życzymy bezszkodowej jazdy.',
  ThankYouText1 = 'Życzymy bezszkodowej jazdy!',
  ThankYouText2 = 'Zespół Mubi',
  ToPay = 'Do zapłaty: ',
  Transfer = 'Przelew',
  TravelThankYouForPurchasing = 'Dziękujemy za zakup ubezpieczenia w\xa0Mubi i życzymy bezpiecznej podróży.',
  TryAgain = 'Spróbuj opłacić jeszcze raz.',
  WarningForPayment = 'Uwaga: Płatności elektroniczne mogą nie działać w\xa0godzinach ',
  WarningForPayment2 = 'Twoja polisa została zawarta poprawnie.<br/>Trwają prace serwisowe, dlatego płatność może zakończyć się błędem. Możesz ponawiać próbę lub zapłacić po zakończeniu prac.<br/>Link do płatności znajdziesz w mailu.<br/>Przepraszamy za utrudnienia.',
  WarrantyInfo = 'Gwarancja bezpiecznego zakupu',
  WireTransfer = 'Przelew tradycyjny',
  WithMubi = 'z Mubi:',
  YearShortcut = '\xa0r.',
  YouCanResign = 'Jeśli jednak się rozmyślisz, możesz odstąpić od umowy w ciągu 30 dni od dziś.',
  YourPolicyWillBeValid = 'Twoje ubezpieczenie będzie ważne od dnia ',
}
